export const experiencesQueryKeys = {
  all: ['experiences'] as const,
  offers: () => [...experiencesQueryKeys.all, 'offers'] as const,
  offerDetail: (offerId: string, brand: string) =>
    [...experiencesQueryKeys.offers(), 'detail', offerId, brand] as const,
  relatedLocations: (offerId: string) => [...experiencesQueryKeys.offers(), offerId, 'relatedLocations'] as const,
  collections: () => [...experiencesQueryKeys.all, 'collections'] as const,
  collectionsList: (onlyActive?: boolean) => [...experiencesQueryKeys.collections(), { onlyActive }] as const,
  carouselMetrics: () => [...experiencesQueryKeys.all, 'carouselMetrics'] as const,
  carouselMetricsList: () => [...experiencesQueryKeys.carouselMetrics(), 'list'] as const,
  homepageMetrics: (params: Record<string, unknown>) =>
    [...experiencesQueryKeys.all, 'homepageMetrics', params] as const,
  homepageGeoValues: (params: Record<string, unknown>) =>
    [...experiencesQueryKeys.all, 'homepageGeoValues', params] as const,
  contentTagPerformance: (params: Record<string, unknown>) =>
    [...experiencesQueryKeys.all, 'contentTagPerformance', params] as const,
  syncLogs: () => [...experiencesQueryKeys.all, 'syncLogs'] as const,
  syncLogsList: (offerId: string) => [...experiencesQueryKeys.syncLogs(), offerId] as const,
  urgencyTags: () => [...experiencesQueryKeys.all, 'urgencyTags'] as const,
  urgencyTagsList: () => [...experiencesQueryKeys.urgencyTags(), 'list'] as const,
};
